import React from "react";
import { Container, UserName, IconWrapper, NavItem, Right, activeStyle, Left, Title } from "./style";
import { ReactComponent as Logo } from '../../assets/icons/logo.svg'
import { SearchInput } from '../FormElements/Inputs'
import { useHistory } from 'react-router-dom'
import { Youtube } from '@styled-icons/entypo-social/Youtube'
import { Telegram } from '@styled-icons/fa-brands/Telegram'
import { Github } from '@styled-icons/boxicons-logos/Github'

function Navbar() {
	const history = useHistory();
	return (
		<Container>
			<Left>
				<Logo onClick={() => history.push('/dashboard')} width="80px" height="80px" />
				<Title onClick={() => history.push('/dashboard')}>
					<span /><span /><span /><span />
            WebBrain Academy
				</Title>
				<SearchInput />
				<NavItem exact activeStyle={activeStyle} to="/docs">Docs </NavItem>
				<NavItem exact activeStyle={activeStyle} to="/components">Components </NavItem>
				<NavItem exact activeStyle={activeStyle} to="/resources">Resources </NavItem>
			</Left>
			<Right>
				<UserName>Muhtorov Sardorbek</UserName>
				<IconWrapper href="https://t.me/smd_94"><Telegram color="#0088CC" size="26px" /></IconWrapper>
				<IconWrapper href='https://youtube.com/c/webbrainacademy'><Youtube color="#FF0F50" size="26px" /></IconWrapper>
				<IconWrapper href="https://github.com/mukhtorov"><Github color="#35465C" size="30px" /></IconWrapper>
			</Right>
		</Container>
	);
}

export default Navbar;
